import { useMemo } from 'react';
import { Select } from '@bigcommerce/big-design';

export default function StatesDropdown({ getValue, setValue }) {
	const states = {
		label: 'United States',
		options: [
			{ value: 'AL', content: 'Alabama' },
			{ value: 'AK', content: 'Alaska' },
			{ value: 'AZ', content: 'Arizona' },
			{ value: 'AR', content: 'Arkansas' },
			{ value: 'CA', content: 'California' },
			{ value: 'CO', content: 'Colorado' },
			{ value: 'CT', content: 'Connecticut' },
			{ value: 'DE', content: 'Delaware' },
			{ value: 'FL', content: 'Florida' },
			{ value: 'GA', content: 'Georgia' },
			{ value: 'HI', content: 'Hawaii' },
			{ value: 'ID', content: 'Idaho' },
			{ value: 'IL', content: 'Illinois' },
			{ value: 'IN', content: 'Indiana' },
			{ value: 'IA', content: 'Iowa' },
			{ value: 'KS', content: 'Kansas' },
			{ value: 'KY', content: 'Kentucky' },
			{ value: 'LA', content: 'Louisiana' },
			{ value: 'ME', content: 'Maine' },
			{ value: 'MD', content: 'Maryland' },
			{ value: 'MA', content: 'Massachusetts' },
			{ value: 'MI', content: 'Michigan' },
			{ value: 'MN', content: 'Minnesota' },
			{ value: 'MS', content: 'Mississippi' },
			{ value: 'MO', content: 'Missouri' },
			{ value: 'MT', content: 'Montana' },
			{ value: 'NE', content: 'Nebraska' },
			{ value: 'NV', content: 'Nevada' },
			{ value: 'NH', content: 'New Hampshire' },
			{ value: 'NJ', content: 'New Jersey' },
			{ value: 'NM', content: 'New Mexico' },
			{ value: 'NY', content: 'New York' },
			{ value: 'NC', content: 'North Carolina' },
			{ value: 'ND', content: 'North Dakota' },
			{ value: 'OH', content: 'Ohio' },
			{ value: 'OK', content: 'Oklahoma' },
			{ value: 'OR', content: 'Oregon' },
			{ value: 'PA', content: 'Pennsylvania' },
			{ value: 'RI', content: 'Rhode Island' },
			{ value: 'SC', content: 'South Carolina' },
			{ value: 'SD', content: 'South Dakota' },
			{ value: 'TN', content: 'Tennessee' },
			{ value: 'TX', content: 'Texas' },
			{ value: 'UT', content: 'Utah' },
			{ value: 'VT', content: 'Vermont' },
			{ value: 'VA', content: 'Virginia' },
			{ value: 'WA', content: 'Washington' },
			{ value: 'WV', content: 'West Virginia' },
			{ value: 'WI', content: 'Wisconsin' },
			{ value: 'WY', content: 'Wyoming' },
		],
	};
	const provinces = {
		label: 'Canada Provinces',
		options: [
			{ value: 'AB', content: 'Alberta' },
			{ value: 'BC', content: 'British Columbia' },
			{ value: 'MB', content: 'Manitoba' },
			{ value: 'NB', content: 'New Brunswick' },
			{ value: 'NL', content: 'Newfoundland and Labrador' },
			{ value: 'NT', content: 'Northwest Territories' },
			{ value: 'NS', content: 'Nova Scotia' },
			{ value: 'NU', content: 'Nunavut' },
			{ value: 'ON', content: 'Ontario' },
			{ value: 'PE', content: 'Prince Edward Island' },
			{ value: 'QC', content: 'Quebec' },
			{ value: 'SK', content: 'Saskatchewan' },
			{ value: 'YT', content: 'Yukon Territory' },
		],
	};

	const stateProvinceValue = useMemo(() => {
		const stateName = getValue('state_or_province');
		const state = states.options.find(
			(option) =>
				stateName === option.content || stateName === option.value,
		);
		if (state?.value) return state.value;
		const province = provinces.options.find(
			(option) =>
				stateName === option.content || stateName === option.value,
		);
		if (province?.value) return province.value;
		return '';
	}, [getValue('state_or_province')]);

	return (
		<Select
			filterable={true}
			label="Province/State"
			options={[states, provinces]}
			value={stateProvinceValue}
			onOptionChange={(value) => setValue('state_or_province', value)}
			placement={'bottom-start'}
			required
		/>
	);
}
